/**
 * Utility to check if cache is current by comparing cached timestamp to now
 * If now minus timestamp is larger than expireTime, cache has expired
 *
 * @param {string, number} timestamp Cached timestamp to compare to now
 * @param {number} expireTime Milliseconds difference between timestamp and now to determine currency of cached data
 * @returns {boolean} True if cache is current, false if not
 */
export const cacheIsCurrent = (timestamp: string | number, expireTime: number) => {
  return timestamp && !Number.isNaN(timestamp) && Date.now() - Number(timestamp) < expireTime;
};
